import React, {Component} from 'react';
const { connect } = require('react-redux');
import queryString from 'query-string';
import {diff} from 'deep-object-diff';
import Helmet from 'react-helmet';

import {getWishlists} from 'reducers/wishlists';

import 'sass/wishlist.scss';

import HeaderWishlist from '../components/wishlist/HeaderWishlist';
import WishlistUser from '../components/wishlist/WishlistUser';
import Footer from '../components/Footer';
import ListWrapper from 'components/common/ListWrapper.js';
import {Link} from 'components/ReactRouterDomLocalized';
import Pagination from 'components/Pagination';

import {t, dt} from 'l10n';

import paths from 'paths';
const LIMIT = 10;

class Wishlists extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: this.constructor.getSearchObject(props)
        };

        this.paginationUrlFn = this.paginationUrlFn.bind(this);
    }

    static fetchData({dispatch, location, match}) {
        return dispatch(getWishlists({}));
    }

    static getSearchObject({location}) {
        return queryString.parse(location.search);
    }

    componentDidMount() {
        let {dispatch, wishlists} = this.props;
        let {search} = this.state;

        // todo: check if page in redux != page in own state
        if (!wishlists.list) {
            dispatch(getWishlists(search));
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            search: this.constructor.getSearchObject(nextProps)
        });
    }

    componentWillUpdate(nextProps, nextState) {
        let {dispatch} = this.props;

        let searchDiff = diff(this.state.search, nextState.search);

        if (Object.keys(searchDiff).length) {
            dispatch(getWishlists(nextState.search));
        }
    }

    paginationUrlFn(page) {
        return {
            pathname: paths.wishlists.path,
            search: queryString.stringify({...this.state.search, page})
        }
    }

    render() {
        let {wishlists} = this.props,
            {list, totalCount} = wishlists;

        let {search} = this.state;

        return (
            <div id="wrapper">
                <Helmet>
                    <title>{dt('meta', 'Wishlists of BobTV members. Naughty and erotic gifts.')}</title>
                </Helmet>

                <HeaderWishlist search={search}/>
                <aside className="wishlists">
                    <div className="content">
                        <ListWrapper
                            className="list"
                            list={list}
                            mapFn={(item) => <WishlistUser user={item.user} wishlist={item.wishlist} key={item.user.id}/>}
                            placeholder={
                                <p className="placeholder">
                                    {t('Sorry, there is no wishlists found.')}<br/>
                                    <Link to={paths.wishlists.path}>{t('View all wishlists')}</Link>
                                </p>
                            }
                        />
                        <div className="pagination-container">
                            <Pagination
                                itemsPerPage={LIMIT}
                                totalCount={totalCount}
                                currentPage={search.page}
                                urlFn={this.paginationUrlFn}
                            />
                        </div>
                    </div>
                </aside>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        wishlists: state.wishlists,
    }),
    null
)(Wishlists)


// WEBPACK FOOTER //
// ./src/containers/Wishlists.js